export default class extends Controller {

  toggleSideNavbar(){
    if (document.body.getAttribute('data-leftbar-compact-mode')) {
      document.body.removeAttribute('data-leftbar-compact-mode');
    } else {
      document.body.setAttribute('data-leftbar-compact-mode', 'condensed');
    }
  }

  showSideNavbar(){
    document.body.removeAttribute('data-leftbar-compact-mode');
    document.body.classList.toggle("sidebar-enable");
  }
}
